module.exports = __webpack_public_path__ + "static/img/brand-1.131c59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/brand-1.png
// module id = okuz
// module chunks = 0